function formatCurrency(value: number) {
  const { locale } = useI18n() // useI18n is a VueI18n instance
  return new Intl.NumberFormat(locale.value, {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

export default formatCurrency
